import { useMemo } from 'react';

import { useGetOpportunityFieldHistory } from '~/hooks/apis/contracting/useGetOpportunityFieldHistory';

import { toFieldHistoryEntries } from '../shared/fieldHistory/toFieldHistoryEntries';

import { DEAL_HISTORY_ENTITY_TYPE_BY_TAB } from './constants';
import type { DealInformationTab } from './types';

/** The newest `limit` history rows for the active tab's record type; untracked tabs fetch nothing. */
export function useDealFieldHistory(activeTab: DealInformationTab, opportunityId: string | undefined, limit: number) {
  const entityType = DEAL_HISTORY_ENTITY_TYPE_BY_TAB[activeTab];
  const { data, dataUpdatedAt, error, isLoading } = useGetOpportunityFieldHistory(opportunityId, entityType, { limit });
  const entries = useMemo(() => toFieldHistoryEntries(data?.result ?? []), [data]);

  return {
    entries,
    error,
    isLoading,
    isTracked: !!entityType,
    lastUpdatedAt: dataUpdatedAt ? new Date(dataUpdatedAt).toISOString() : undefined,
    totalCount: data?.pagination.total_items ?? 0,
  };
}
